import angular from 'angular';

(() => {
  const serializeQuery = (query = {}) => {
    let token = '';

    for (const [key, value] of Object.entries(query)) {
      if (value === undefined) {
        continue;
      } // Pipe delimits if value is an array;


      let pipedArray;

      if (Array.isArray(value)) {
        pipedArray = value.join('|');
      }

      const delimiter = `${!token.length ? '?' : '&'}`;
      token += `${delimiter}${encodeURIComponent(key)}=${encodeURIComponent(pipedArray || value)}`;
    }

    return token;
  };

  const getApiErrorMessage = (err, defaultMessage = 'Something went wrong, please try again.') => {
    return err.data && err.data.message ? err.data.message.summary : defaultMessage;
  };

  const filterParams = (payload, whitelist) => {
    const filtered = {};

    for (const key in payload) {
      if (whitelist.indexOf(key) > -1) {
        filtered[key] = payload[key];
      }
    }

    return filtered;
  };

  class BaseService {
    constructor($http, Utils, Endpoints, Constants, API_URL) {
      'ngInject';

      Object.assign(this, {
        $http,
        Endpoints,
        Constants,
        Utils,
        API_URL,
        serializeQuery,
        getApiErrorMessage,
        filterParams
      });
    }

  }

  BaseService.$inject = ["$http", "Utils", "Endpoints", "Constants", "API_URL"];
  angular.module('pims').service('BaseService', BaseService);
})();